import React, {Component, ReactElement, ReactNode} from 'react'
import {
    AdditionalChargeInfo,
    NatGetAdditionalBillingList,
    SearchCondition,
    SearchConditionPageInfo,
    SearchResult,
} from './repository/NatGetAdditionalBillingList'
import {SELECT_USER_TYPE} from '../../../CodeMaster'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {Nullable} from '../../../app/TypeHelpers'
import ListSearchFormArea from '../../../styledComponents/adminPage/ListSearchFormArea'
import {SearchResultCountDisplayProps} from '../../../styledComponents/adminPage/SearchResultCountDisplay'
import {FlexContainer, LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {AdminDefaultMediumButton} from '../../../styledComponents/adminPage/Buttons'

import SearchPageActionArea from '../../../styledComponents/adminPage/SearchPageActionArea';
import {PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate';
import SortableTableHeader, {
    SortableTableHeaderCell
} from '../../../styledComponents/adminPage/SortablePaginationTableHeader';
import SortablePaginationTable from '../../../styledComponents/adminPage/SortablePaginationTable';
import SortablePaginationTableBody from '../../../styledComponents/adminPage/SortablePaginationTableBody';
import {SortDirection} from '@mui/material/TableCell';
import {SortOrder} from '../../../components/shared/SortOrder';
import {COMMON_CONSTANTS} from '../../../CommonConstants';
import {formatDateTimeForUpdateDate, formatForDateInput} from '../../../formatters/formatDate';
import {
    ConditionButtonCell,
    ConditionCategoryCell,
    ConditionColumNameCell,
    ConditionInputCell,
    ConditionTable,
    ConditionTableBody,
    ConditionTableRow,
} from '../../../styledComponents/adminPage/ConditionTable'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {StyledDiv, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import NatResidentUserSelectionComponent from '../common/admin/NatResidentUserSelectionComponent'
import NatRidgeRepo from '../ridge/repository/NatRidgeRepo'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import {ResidentUserInfo} from '../roomToResident/repository/NatGetRoomToResident'
import NatFacilityReserveRepo from './repository/NatFacilityReserveRepo'
import {Messages} from '../../../Messages'
import {formatNumberWithCommas} from '../../../formatters/formatNumberWithCommas'
import {CurrentDateTime, NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {getYearAfterNextDateFac, getYearDateFac, nullToBlank} from '../../common/util/Natutil'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {getDisplayUserNameForManagement} from '../../../components/reservations/admin/AdminReserveHelper'
import {Location} from 'react-router-dom'

import {Link, TableCell, TableRow} from '@mui/material';

const KEY_SEARCH_CONDITION: string = 'adminAdditionalBillingListPageSearchCondition'
const SELECTED_CONDOMINIUM_CD: string = 'selectedCondominiumCd'

interface Props {
    RidgeRepo: NatRidgeRepo
    facilityReserveRepo: NatFacilityReserveRepo
    RoomToResidentRepo: NatRoomToResidentRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    userId: string
    userRidgeCd: string
    userRoomNumber: string
    userRidgeName: string
    userName: string
    adminUserName: string
    reserveStartDate: string
    reserveEndDate: string
    reserveStartDateMin: string
    reserveStartDateMax: string
    reserveEndDateMin: string
    reserveEndDateMax: string
    currentDateTime: CurrentDateTime
    dialogOpenSelectResidentUser: boolean
    selectedResidenUsersRoomInfo: string
    selectedCondominiumCd: string
    additionalChargeList: AdditionalChargeInfo[]
    additionalChargeSearchResult: SearchResult
    searchCondition: SearchCondition
    searchConditionPageInfo: SearchConditionPageInfo
    searchConditionSortInfo: SortOrder[]
    noResultMessage: string
    isLoadCompleted: boolean
}

interface LastSearchCondition extends SearchCondition {
    pageNum?: number
}

class NatAdminAdditionalBillingListPage extends Component<Props & AdminPagePropsSet, States> {

    subSortKey: SortOrder = new SortOrder('facilityReserveId', 'asc')

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        const selectedCondominiumGroupId: Nullable<string> =
            SessionStorageHelper.getStringItemOrNull(SELECTED_CONDOMINIUM_CD)


        // 前回検索条件が保持されていればデフォルト値として設定する
        let defaultSearchCondition: LastSearchCondition = {}
        const sessionStorageSearchCondition: string | null = window.sessionStorage.getItem(KEY_SEARCH_CONDITION)
        if (sessionStorageSearchCondition) {
            defaultSearchCondition = JSON.parse(sessionStorageSearchCondition)
        }

        this.state = {
            userId: (defaultSearchCondition.userId) ?
                defaultSearchCondition.userId : '',
            userRidgeCd: (defaultSearchCondition.userRidgeCd) ?
                defaultSearchCondition.userRidgeCd : '',
            userRoomNumber: (defaultSearchCondition.userRoomNumber) ?
                defaultSearchCondition.userRoomNumber : '',
            userRidgeName: (defaultSearchCondition.dispUserRidgeName) ?
                defaultSearchCondition.dispUserRidgeName : '',
            userName: (defaultSearchCondition.dispUserName) ?
                defaultSearchCondition.dispUserName : '',
            adminUserName: (defaultSearchCondition.dispAdminUserName) ?
                defaultSearchCondition.dispAdminUserName : '',
            reserveStartDate: (defaultSearchCondition.reserveStartDate) ?
                defaultSearchCondition.reserveStartDate : '',
            reserveEndDate: (defaultSearchCondition.reserveEndDate) ?
                defaultSearchCondition.reserveEndDate : '',
            reserveStartDateMax: (defaultSearchCondition.reserveEndDate) ?
                defaultSearchCondition.reserveEndDate : '',
            reserveStartDateMin: '',
            reserveEndDateMax: '',
            reserveEndDateMin: (defaultSearchCondition.reserveStartDate) ?
                defaultSearchCondition.reserveStartDate : '',
            currentDateTime: {
                currentDateTime: '',
                holidayFlag: '',
            },
            dialogOpenSelectResidentUser: false,
            selectedResidenUsersRoomInfo: '',
            selectedCondominiumCd: (selectedCondominiumGroupId) ? selectedCondominiumGroupId : '1',
            additionalChargeList: [],
            additionalChargeSearchResult: {},
            searchCondition: defaultSearchCondition,
            searchConditionPageInfo: {
                ['pageNum']: (defaultSearchCondition.pageNum) ?
                    defaultSearchCondition.pageNum : COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[0],
                ['page']: COMMON_CONSTANTS.FIRST_PAGE,
            },
            searchConditionSortInfo: [
                new SortOrder('updateDatetime', 'desc'),
            ],
            noResultMessage: '',
            isLoadCompleted: false,
        }

        this.handleOpenResidentUserSelectionDialog = this.handleOpenResidentUserSelectionDialog.bind(this)
        this.setSelectedResidentUserInfo = this.setSelectedResidentUserInfo.bind(this)
        this.closeSelectResidentUserDiaLog = this.closeSelectResidentUserDiaLog.bind(this)
        this.onChangeExtractStartDate = this.onChangeExtractStartDate.bind(this)
        this.onChangeExtractEndDate = this.onChangeExtractEndDate.bind(this)
        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleSortMessages = this.handleSortMessages.bind(this)
        this.registerAdditionalBilling = this.registerAdditionalBilling.bind(this)
        this.handleResidentUserClear = this.handleResidentUserClear.bind(this)
    }

    async componentDidMount(): Promise<void> {
        try {
            // 追加課金一覧取得
            await this.getAdditionalBillingList(
                this.state.searchCondition,
                this.state.searchConditionPageInfo,
                this.state.searchConditionSortInfo,
            )

            // 現在日時
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (currentDateTime && currentDateTime.details) {
                this.setState({
                    reserveStartDateMin: getYearDateFac(),
                    reserveStartDateMax: getYearAfterNextDateFac(currentDateTime.details.currentDateTime),
                    reserveEndDateMin: getYearDateFac(),
                    reserveEndDateMax: getYearAfterNextDateFac(currentDateTime.details.currentDateTime),
                    currentDateTime: currentDateTime.details,
                })
            }
        } finally {
            this.setState({isLoadCompleted: true})
        }
        this.showInitialMessage()
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
        this.props.eventEmitter.closeLoading()
    }

    onChangeExtractStartDate(date: Nullable<Date>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        if (date !== null) {
            searchCondition.reserveStartDate = formatForDateInput(date.toString())
        } else {
            searchCondition.reserveStartDate = ''
        }

        this.setState({
            reserveStartDate: date !== null ? date.toString() : '',
            reserveEndDateMin: date !== null ? date.toString() : getYearDateFac(),
            searchCondition: searchCondition,
        })
    }

    onChangeExtractEndDate(date: Nullable<Date>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        if (date !== null) {
            searchCondition.reserveEndDate = formatForDateInput(date.toString())
        } else {
            searchCondition.reserveEndDate = ''
        }

        this.setState({
            reserveEndDate: date !== null ? date.toString() : '',
            reserveStartDateMax: date !== null ?
                date.toString() : getYearAfterNextDateFac(this.state.currentDateTime.currentDateTime),
            searchCondition: searchCondition,
        })
    }

    async getAdditionalBillingList(
        searchCondition: SearchCondition,
        searchConditionPageInfo: SearchConditionPageInfo,
        searchConditionSortInfos: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const response: Nullable<NatGetAdditionalBillingList> = await this.props.asyncCallFunction(
                this.props.facilityReserveRepo.getAdditionalBillingList.bind(
                    this.props.facilityReserveRepo,
                    searchCondition,
                    searchConditionPageInfo,
                    [...searchConditionSortInfos, this.subSortKey]),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (response && response.details) {
                this.setState({
                    additionalChargeList: response.details.additionalChargeInfo,
                    additionalChargeSearchResult: response.details.searchResult,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    registerAdditionalBilling(): void {
        this.props.navigate('/admin/additionalBillingRegister')
    }


    searchResults(): SearchResultCountDisplayProps {
        if (this.state.additionalChargeList.length === 0) {
            if (!Object.keys(this.state.searchCondition).length) {
                return {noResultMessage: Messages.IOPCC0015.toString('追加課金')}
            }
            return {noResultMessage: Messages.IOPCC0014.toString('')}
        }

        return {
            totalCount: this.state.additionalChargeSearchResult.total ?
                this.state.additionalChargeSearchResult.total : undefined,
            rowsPerPage: this.state.searchConditionPageInfo.pageNum,
            page: this.state.searchConditionPageInfo.page,
        }
    }

    async onClickSearchButton(): Promise<void> {
        this.beforeUserAction()
        // 検索条件を保持
        SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(this.state.searchCondition))
        const searchConditionPageInfo: SearchConditionPageInfo = {
            pageNum: this.state.searchConditionPageInfo.pageNum,
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
        await this.getAdditionalBillingList(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    handleOpenResidentUserSelectionDialog(): void {
        this.setState({
            dialogOpenSelectResidentUser: true,
        })
    }

    handleResidentUserClear(): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.userId = ''
        searchCondition.userRidgeCd = ''
        searchCondition.userRoomNumber = ''
        searchCondition.dispUserRidgeName = ''
        searchCondition.dispUserName = ''
        searchCondition.dispAdminUserName = ''

        this.setState({
            userId: '',
            userRidgeCd: '',
            userRoomNumber: '',
            userRidgeName: '',
            userName: '',
            adminUserName: '',
            searchCondition: searchCondition,
        })
    }

    closeSelectResidentUserDiaLog(): void {
        this.setState({dialogOpenSelectResidentUser: false})
    }

    async setSelectedResidentUserInfo(selectedResidentUserInfo: ResidentUserInfo): Promise<void> {
        const displayUserNameForManagement = getDisplayUserNameForManagement(selectedResidentUserInfo)

        // 検索条件
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.userId = selectedResidentUserInfo.sutekiNetId
        searchCondition.userRidgeCd = selectedResidentUserInfo.ridgeCd
        searchCondition.userRoomNumber = selectedResidentUserInfo.roomNumber
        searchCondition.dispUserRidgeName = selectedResidentUserInfo.ridgeName
        searchCondition.dispUserName = `${nullToBlank(selectedResidentUserInfo.familyName)} ${nullToBlank(selectedResidentUserInfo.firstName)}`
        searchCondition.dispAdminUserName = `${nullToBlank(selectedResidentUserInfo.adminFamilyName)} ${nullToBlank(selectedResidentUserInfo.adminFirstName)}`

        this.setState({
            userId: selectedResidentUserInfo.sutekiNetId,
            userRidgeCd: selectedResidentUserInfo.ridgeCd,
            userRoomNumber: selectedResidentUserInfo.roomNumber,
            userRidgeName: selectedResidentUserInfo.ridgeName,
            userName: `${nullToBlank(selectedResidentUserInfo.familyName)} ${nullToBlank(selectedResidentUserInfo.firstName)}`,
            adminUserName: displayUserNameForManagement,
            searchCondition: searchCondition,
            dialogOpenSelectResidentUser: false,
        })
    }


    renderSelectedResidentUserInfo(): ReactNode {
        if (this.state.userId === '') {
            return ''
        }

        return (
            <>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>部屋番号</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValue>
                        {this.state.userRidgeName} {this.state.userRoomNumber}
                    </SelectedModalInfoItemValue>
                </SelectedFlexWrapperWide>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>氏名</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValueCondominium>
                        {this.state.userName}
                    </SelectedModalInfoItemValueCondominium>
                </SelectedFlexWrapperWide>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>管理者確認用氏名</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValueCondominium>
                        {nullToBlank(this.state.adminUserName)}
                    </SelectedModalInfoItemValueCondominium>
                </SelectedFlexWrapperWide>
            </>
        )
    }


    renderAdditionalBillingInfo(): ReactNode {
        return (
            <>
                <ConditionTableRow>
                    <ConditionCategoryCell>居住者情報</ConditionCategoryCell>
                    <ConditionColumNameCell>ユーザ</ConditionColumNameCell>
                    <ConditionInputCell colSpan={2}>
                        <SelectedFlexContainer>
                            <SelectedFlexWrapper>
                                <AdminDefaultMediumButton
                                    onClick={this.handleOpenResidentUserSelectionDialog}>
                                    選択する
                                </AdminDefaultMediumButton>
                            </SelectedFlexWrapper>
                            {this.renderSelectedResidentUserInfo()}
                            {this.state.userId !== '' &&
                                <SelectedFlexWrapper>
                                    <AdminDefaultMediumButton
                                        onClick={this.handleResidentUserClear}>
                                        クリア
                                    </AdminDefaultMediumButton>
                                </SelectedFlexWrapper>
                            }
                        </SelectedFlexContainer>
                    </ConditionInputCell>

                </ConditionTableRow>
                {this.state.dialogOpenSelectResidentUser &&
                    <NatResidentUserSelectionComponent
                        roomToResidentRepo={this.props.RoomToResidentRepo}
                        ridgeRepo={this.props.RidgeRepo}
                        selectUserType={SELECT_USER_TYPE.USER.value}
                        closeSelectResidentUserDiaLog={this.closeSelectResidentUserDiaLog}
                        setSelectedResidentUserInfo={this.setSelectedResidentUserInfo}
                        selectedCondominiumCd={this.state.selectedCondominiumCd}
                        invalidUserSelectFlag={true}
                        allResidentStatus={true}
                        eventEmitter={this.props.eventEmitter}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        asyncCallFunction={this.props.asyncCallFunction}
                    />
                }
                <ConditionTableRow>
                    <ConditionCategoryCell>日付情報</ConditionCategoryCell>
                    <ConditionColumNameCell>利用期間</ConditionColumNameCell>
                    <ConditionInputCell>
                        <LeftRowFlexContainer>
                            <TermWrapper>
                                <FlexBasis style={{paddingBottom: 4, paddingTop: 8}}>
                                    <PPDatePicker
                                        onChangeDate={this.onChangeExtractStartDate}
                                        value={(this.state.reserveStartDate !== '') ?
                                            new Date(this.state.reserveStartDate) : null
                                        }
                                        minDate={(this.state.reserveStartDateMin !== '') ?
                                            new Date(this.state.reserveStartDateMin) : undefined
                                        }
                                        maxDate={(this.state.reserveStartDateMax !== '') ?
                                            new Date(this.state.reserveStartDateMax) : undefined
                                        }
                                        autoFocus
                                    />
                                </FlexBasis>
                                <TermTxt>から</TermTxt>
                            </TermWrapper>
                            <TermWrapper>
                                <FlexBasis style={{paddingBottom: 4, paddingTop: 8}}>
                                    <PPDatePicker
                                        onChangeDate={this.onChangeExtractEndDate}
                                        value={(this.state.reserveEndDate !== '') ?
                                            new Date(this.state.reserveEndDate) : null
                                        }
                                        minDate={(this.state.reserveEndDateMin !== '') ?
                                            new Date(this.state.reserveEndDateMin) : undefined
                                        }
                                        maxDate={(this.state.reserveEndDateMax !== '') ?
                                            new Date(this.state.reserveEndDateMax) : undefined
                                        }
                                    />
                                </FlexBasis>
                                <TermTxt>まで</TermTxt>
                            </TermWrapper>
                        </LeftRowFlexContainer>
                    </ConditionInputCell>
                    <ConditionButtonCell colSpan={3}>
                        <AdminDefaultMediumButton
                            onClick={this.onClickSearchButton}>
                            追加課金を検索する
                        </AdminDefaultMediumButton>
                    </ConditionButtonCell>
                </ConditionTableRow>
            </>
        )
    }


    async handleChangePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.beforeUserAction()
        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.page = newPage
        await this.getAdditionalBillingList(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }


    async handleSortMessages(sortKey: string): Promise<void> {
        this.beforeUserAction()

        let sortDirection: SortDirection = this.getSortDirection(sortKey)
        if (sortDirection === false || sortDirection === 'desc') {
            sortDirection = 'asc'
        } else {
            sortDirection = 'desc'
        }

        const sortOrders: SortOrder[] = [new SortOrder(sortKey, sortDirection)]
        await this.getAdditionalBillingList(
            this.state.searchCondition,
            this.state.searchConditionPageInfo,
            sortOrders,
        )
        this.setState({searchConditionSortInfo: sortOrders})
    }

    async handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.beforeUserAction()

        // 検索条件を保持
        const lastSearchCondition: LastSearchCondition = {
            userId: this.state.searchCondition.userId,
            userRidgeCd: this.state.searchCondition.userRidgeCd,
            userRoomNumber: this.state.searchCondition.userRoomNumber,
            reserveStartDate: this.state.searchCondition.reserveStartDate,
            reserveEndDate: this.state.searchCondition.reserveEndDate,
            pageNum: Number(event.target.value),
        }

        SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(lastSearchCondition))

        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.pageNum = Number(event.target.value)
        searchConditionPageInfo.page = COMMON_CONSTANTS.FIRST_PAGE
        await this.getAdditionalBillingList(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})

    }

    renderAdditionalChargeRecord(additionalCharge: AdditionalChargeInfo): ReactElement {

        const additionalChargeUrl: string = `/admin/additionalBilling/${additionalCharge.facilityReserveId}`
        return (
            <TableRow key={additionalCharge.facilityReserveId}>
                <TableCellWordBreakAll align={'center'}>
                    <Link href={additionalChargeUrl} underline="hover">{additionalCharge.reserveTitle}</Link>
                </TableCellWordBreakAll>
                <TableCell align={'center'}>
                    {additionalCharge.facilityName}
                </TableCell>
                <TableCell align={'center'}>
                    {additionalCharge.userRidgeName} {additionalCharge.userRoomNumber}
                </TableCell>
                <TableCell align={'center'}>
                    {additionalCharge.userFamilyName} {additionalCharge.userFirstName}
                </TableCell>
                <TableCell align={'center'}>
                    {additionalCharge.adminFamilyName} {additionalCharge.adminFirstName}
                </TableCell>
                <TableCell align={'center'}>
                    {formatForDateInput(additionalCharge.reserveStartDatetime)}
                </TableCell>
                <TableCell align={'center'}>
                    {formatNumberWithCommas(Number(additionalCharge.facilityUseCharge))}円
                </TableCell>
                <TableCell align={'center'}>
                    {formatDateTimeForUpdateDate(additionalCharge.updateDatetime)}
                </TableCell>
            </TableRow>
        )
    }

    renderMessageTable(additionalChargeList: AdditionalChargeInfo[]): Nullable<ReactElement> {
        if (additionalChargeList.length === 0) {
            return null
        }
        const headers: SortableTableHeaderCell[] = [
            {id: 'title', label: 'タイトル'},
            {id: 'facilityName', label: '施設名'},
            {id: 'roomNumber', label: '部屋番号'},
            {id: 'name', label: '氏名'},
            {id: 'adminName', label: '管理者確認用氏名'},
            {id: 'reserveStartDatetime', label: '利用日'},
            {id: 'facilityUseCharge', label: '金額'},
            {
                id: 'updateDatetime',
                label: '更新日時',
                sortable: true,
                direction: this.getSortDirection('updateDatetime'),
            },
        ]

        return (
            <SortablePaginationTable
                paginationProps={{
                    count: this.state.additionalChargeSearchResult.total ?
                        this.state.additionalChargeSearchResult.total : 0,
                    rowsPerPage:
                        this.state.searchConditionPageInfo.pageNum ? this.state.searchConditionPageInfo.pageNum : 0,
                    page: this.state.searchConditionPageInfo.page ? this.state.searchConditionPageInfo.page : 0,
                    onPageChange: this.handleChangePage,
                    onRowsPerPageChange: this.handleChangeRowsPerPage,
                }}
            >

                <SortableTableHeader
                    headers={headers}
                    onSortOrderChange={this.handleSortMessages}
                />
                <SortablePaginationTableBody>
                    {this.state.additionalChargeList.map(
                        renderAdditionalCharge => this.renderAdditionalChargeRecord(renderAdditionalCharge),
                    )}
                </SortablePaginationTableBody>
            </SortablePaginationTable>
        )
    }

    getSortDirection(sortKey: string): SortDirection {
        const sortOrder: SortOrder | undefined =
            this.state.searchConditionSortInfo.find(order => order.sortKey === sortKey)
        if (sortOrder === undefined) {
            return false
        }
        return sortOrder.sortDirection
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <ListSearchFormArea
                    searchResult={this.searchResults()}
                    onEnterKey={this.onClickSearchButton}
                >
                    <ConditionTable>
                        <ConditionTableBody>
                            {this.renderAdditionalBillingInfo()}
                        </ConditionTableBody>
                    </ConditionTable>
                </ListSearchFormArea>
                <SearchPageActionArea>
                    <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_ADD_CHARGE}>
                        <AdminDefaultMediumButton onClick={this.registerAdditionalBilling}>
                            新規
                        </AdminDefaultMediumButton>
                    </AuthorityChecker>
                </SearchPageActionArea>
                <PageMainArea>
                    {this.renderMessageTable(this.state.additionalChargeList)}
                </PageMainArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminAdditionalBillingListPage)

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`
const TermWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: flex-start;
`

const TermTxt: StyledSpan = styled.span`
  padding: 0 5px 0 5px;
`

const SelectedModalInfoItemValue: StyledSpan = styled.span`
  font-weight: bolder;
  white-space: normal;
  margin-right: 20px;
`

const SelectedModalInfoItemValueCondominium = styled(SelectedModalInfoItemValue)`
  margin-right: 0;
  white-space: normal;
  word-break: break-all;
`

const SelectedFlexContainer = styled(FlexContainer)`
  flex-direction: row;
  align-items: flex-start;
`

const SelectedFlexWrapper = styled.div`
  display: flex;
  padding-right: 15px;
  flex: 1 1 0%;
  align-items: flex-start;
`

const SelectedFlexWrapperWide = styled(SelectedFlexWrapper)`
  flex-grow: 2;
`

const SelectedModalInfoItemLabel: StyledSpan = styled.span`
  font-size: smaller;
  white-space: nowrap;
  margin-left: 20px;
  margin-right: 20px;
`

const FlexBasis: StyledDiv = styled.div`
  flex: 1 1 0%;
`
